export const normalizeStr = (value) => {
    return value.trim().replace(/\s+/g, ' ');
};
